import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from '@lt/localization';
import { numToWords } from '../../../../../../utils/stringUtils';
import ExtraPrice from '../../../../components/ExtraInsurance/components/ExtraPrice';

const FlightClassUpgradeInfo = ({ extraPrice, touristsCount }) => {
  const { t } = useTranslation();
  return (
    <div className="checkout-flight__info">
      <div className="checkout-flight__info-item">
        <div className="like-h4">{t('checkout.flight.classUpgrade')}</div>
        <div>
          <ExtraPrice
            className="checkout-flight__extra-price"
            price={extraPrice}
          />
          <span>{`${t('filters.prices.title_on')} ${numToWords(
            touristsCount,
          )}`}</span>
        </div>
      </div>
    </div>
  );
};

FlightClassUpgradeInfo.propTypes = {
  extraPrice: PropTypes.number.isRequired,
  touristsCount: PropTypes.number.isRequired,
};

export default FlightClassUpgradeInfo;
